"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const selector = require("../../selector/index");
const keautils_1 = require("keautils");
function getPageValues(itemsCount, value) {
    const commonPageSizes = [10, 15, 30, 50, 100, 200, 500, 1000, 2000, 5000, 10000];
    const pageSizes = [...commonPageSizes.filter(x => x < itemsCount), itemsCount];
    const selectedSize = (() => {
        const filtrados = pageSizes.filter(x => x <= value.selectedPageSize);
        return filtrados[filtrados.length - 1] || itemsCount;
    })();
    const pageCount = Math.ceil(itemsCount / selectedSize);
    const selectedPage = Math.min(value.selectedPage, pageCount - 1);
    const minPageSize = pageSizes[0];
    return {
        itemsCount,
        pageCount,
        selectedPage,
        selectedSize,
        pageSizes,
        minPageSize
    };
}
exports.getPageValues = getPageValues;
class PaginatorSelector extends React.PureComponent {
    render() {
        const values = getPageValues(this.props.itemsCount, this.props.value);
        return (React.createElement("span", null,
            React.createElement(PageSelector, { count: values.pageCount, selected: values.selectedPage, onValueChanged: page => this.props.onChange(Object.assign({}, this.props.value, { selectedPage: page })) }),
            React.createElement("div", { className: "pull-right" },
                React.createElement(SizeSelector, { pageSizes: values.pageSizes, value: values.selectedSize, onChange: size => this.props.onChange(Object.assign({}, this.props.value, { selectedPageSize: size })) }))));
    }
}
exports.PaginatorSelector = PaginatorSelector;
/**Un selector de pagina */
class PageSelector extends React.PureComponent {
    render() {
        const paginas = keautils_1.range(0, this.props.count).map(x => ({ value: x, label: x + 1, tooltip: "página " + (x + 1) }));
        return (React.createElement(selector.PaginatedButtonSelector, { items: paginas, value: this.props.selected, onChange: value => this.props.onValueChanged(value) }));
    }
}
class SizeSelector extends React.PureComponent {
    render() {
        return (React.createElement(selector.ButtonSelector, { items: this.props.pageSizes.map(x => ({ value: x, label: x, tooltip: x + " elementos por página" })), value: this.props.value, onChange: this.props.onChange }));
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/pageSelector.js
// module id = 2225
// module chunks = 0